export default [
	{
		path: '/stage/scraping-panel',
		name: 'stage_scraping_panel',
		props: true,
		component: () => import(/* webpackChunkName: "stage_scraping_panel" */ '../views/StageScrapingPanel.vue')
	}
]
